// extracted by mini-css-extract-plugin
export default {"baseResponse":"response_baseResponse__tHPr0","textItem":"response_textItem__ZPjgo"};